export default function importCsvVz(paramData) {
    this.processFileInput({accept: '.csv',prefix: paramData.prefix}, file => {
        this.uploadFiles(file, paramData.prefix, 'uploadFileVz');
    });
}